<template>
  <div>
    <div id="print-report">
      <!-- PRINT ONLY -->
      <div class="caption d-none d-print-block mb-3">
        <HeaderPrint />
      </div>

      <!-- end/ PRINT ONLY -->
      <v-card class="mb-3">
        <div class="px-4 pt-3 pb-0">
          <v-row no-gutters class="align-center pb-3">
            <v-col cols="6" md="9">
              <v-btn
                class="white black--text d-print-none"
                small
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-md-none">
              <div class="text-right d-print-none">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <!-- <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
                solo-inverted
                dense
                clearable
              ></v-text-field> -->
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          :items-per-page="-1"
          :hide-default-footer="true"
          :mobile-breakpoint="breakpoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.sales_bets="{ item }">
            <span :class="getColor(item.sales_bets)">{{
              item.sales_bets
            }}</span>
          </template>

          <template v-slot:item.commission_bets="{ item }">
            <span :class="getColor(item.commission_bets)">{{
              item.commission_bets
            }}</span>
          </template>

          <template v-slot:item.comission_local="{ item }">
            <div>
              <v-chip x-small>
                {{ typeCommissionText(item.type_comission) }}
              </v-chip>
            </div>
            <span :class="getColor(item.comission_local)">
              {{ item.comission_local }}
            </span>
          </template>
          <template v-slot:item.prizes_paid="{ item }">
            <span :class="getColor(item.prizes_paid)">{{
              item.prizes_paid
            }}</span>
          </template>
          <template v-slot:item.gross_profit="{ item }">
            <span :class="getColor(item.gross_profit)">{{
              item.gross_profit
            }}</span>
          </template>
          <template v-slot:item.comission_regional="{ item }">
            <span :class="getColor(item.comission_regional)">{{
              item.comission_regional
            }}</span>
          </template>
          <template v-slot:item.netProfit="{ item }">
            <span :class="getColor(item.netProfit)">{{ item.netProfit }}</span>
          </template>

          <!-- <template v-slot:item.comission_regional="{ item }">            
            {{
              (item.gross_profit * (item.comission_regional / 100)).toFixed(2)
            }}
            {{
              someComissionRegional(
                item.gross_profit * (item.comission_regional / 100)
              )
            }}
          </template> -->

          <!-- <template v-slot:item.netProfit="{ item }">
            
            {{
              (
                item.gross_profit -
                item.gross_profit * (item.comission_regional / 100)
              ).toFixed(2)
            }}
            {{
              someGrossLiquid(
                item.gross_profit -
                  item.gross_profit * (item.comission_regional / 100)
              )
            }}
          </template> -->

          <template v-slot:item.name_agent="{ item }">
            <a
              @click="
                $profile.showProfileDrawer(
                  item.id_agent,
                  'regionalManager/agents/getAgent'
                )
              "
            >
              <v-icon color="blue" x-small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
          </template>

          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_local,
                  'regionalManager/locals/getLocal'
                )
              "
            >
              <v-icon color="green" x-small>mdi-account</v-icon>
              {{ item.name_local }}
            </a>
          </template>
        </v-data-table>
      </v-card>
      <!-- Resume -->
      <div class="mt-4" v-if="items.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card elevation="0" class="pa-3">
              <div class="subtitle-1 pb-2">
                {{ $t("periodSummary") }}
                <v-icon class="float-right mr-3" @click="$copy(resumeCopy)">
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <!-- <div class="caption mb-2">{{ $date.formatRange(rangeDate) }}</div> -->
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>{{ $t("qtdBets") }}</td>
                      <td class="text-right">
                        <span>{{ some.countBet || 0 }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("qtdAgents") }}</td>
                      <td class="text-right">
                        <span>{{ some.agents || 0 }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("grossValue") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.salesBets)">{{
                          some.salesBets || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("agentsComissionsLabel") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.commissionBets)">{{
                          some.commissionBets || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("localManagerCommiGross") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.commissionLocal)"
                          >{{ some.commissionLocal || 0 }}
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("prizeValue") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.prizesPaid)">{{
                          some.prizesPaid || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("grossProfit") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.grossProfit)">{{
                          some.grossProfit || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("regionalManagerCommiLiquid") }}</td>
                      <td class="text-right">
                        <span :class="getColor(somaComissionRegional)">{{
                          somaComissionRegional
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("netProfit") }}</td>
                      <td class="text-right">
                        <span :class="getColor(somaGrossLiquid)">{{
                          somaGrossLiquid
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!--/ Resume -->
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "regional-manager-financial-apurationSimplified",
  components: {
    HeaderPrint,
  },
  data: () => ({
    breakpoint: "xs",
    items: [],
    search: "",
    some: {},
    somaGrossLiquid: 0,
    somaComissionRegional: 0,
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        { text: this.$t("localManagerName"), value: "name_local" },
        { text: this.$t("headersAgentName"), value: "name_agent" },
        { text: this.$t("qtdBets"), value: "count_bets" },
        { text: this.$t("betsLabel"), value: "sales_bets" },
        { text: this.$t("agentCommission"), value: "commission_bets" },

        { text: this.$t("prizeValue"), value: "prizes_paid" },
        { text: this.$t("localManagerCommission"), value: "comission_local" },
        { text: this.$t("grossProfit"), value: "gross_profit" },
        {
          text: this.$t("regionalManagerCommission"),
          value: "comission_regional",
        },
        { text: this.$t("netProfit"), value: "netProfit" },
      ];
    },
  },

  watch: {
    saveFilters(val) {
      val && this.requestApi();
    },
  },

  methods: {
    resetPage() {
      this.search = "";
      this.some = {};
      this.items = [];
    },

    async requestApi() {
      this.resetPage();

      const body = {
        ...this.rangeDate,
        id_agente: this.id_agent,
        id_local: this.id_local,
        export: this.exportDoc,
      };

      let response;

      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/regionalManager/retail/financial/extract",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/regionalManager/retail/financial/extract",
          body
        );
      }

      if (response.length == 0) return;

      this.items = response.dados.map((item) => {
        if (item.type_comission == "ngr") {
          if (item.comission_ngr_local < "0") {
            item.comission_local = "0";
          } else {
            item.comission_local = (
              Number(item.comission_ngr_local) * -1
            ).toFixed(2);
          }
          item.gross_profit = item.gross_profit_ngr;
        } else {
          item.comission_local = (Number(item.comission_local) * -1).toFixed(2);
        }

        //  Logic Comission Regional
        item.comission_regional = (
          Number(item.gross_profit) *
          (Number(item.comission_regional) / 100)
        ).toFixed(2);
        this.someComissionRegional(item.comission_regional);

        // Logic Lucro líquido (Net Profit);
        var netProfit = (
          Number(item.gross_profit) - Number(item.comission_regional)
        ).toFixed(2);
        this.someGrossLiquid(netProfit);

        this.$set(item, "netProfit", netProfit);

        item.commission_bets = Number(item.commission_bets) * -1;

        // item.comission_local =
        //   item.type_commission == "ngr"
        //     ? Number(item.comission_ngr_local) * -1
        //     : Number(item.comission_local) * -1;
        item.prizes_paid = Number(item.prizes_paid) * -1;
        return item;
      });

      var dt_start = response.date_start.replace(" ", "T");
      var dt_end = response.date_final.replace(" ", "T");

      this.$date.buildRangeUi(dt_start, dt_end);
      this.resume(this.items);
    },

    setData(data) {
      this.resetPage();
      this.apuration = data;
    },

    someGrossLiquid(val) {
      this.some.grossLiquid = (this.some.grossLiquid || 0) + Number(val);
      var soma = this.some.grossLiquid;
      this.somaGrossLiquid = soma.toFixed(2);
    },

    someComissionRegional(val) {
      this.some.commissionRegional =
        (this.some.commissionRegional || 0) + Number(val);
      let soma = this.some.commissionRegional;
      this.somaComissionRegional = soma.toFixed(2);
    },

    resume(items) {
      items.forEach((item) => {
        this.some.countBet =
          (this.some.countBet || 0) + Number(item.count_bets);

        this.some.salesBets =
          (this.some.salesBets || 0) + Number(item.sales_bets);

        this.some.commissionBets =
          (this.some.commissionBets || 0) + Number(item.commission_bets);

        this.some.commissionLocal =
          (this.some.commissionLocal || 0) + Number(item.comission_local);

        this.some.prizesPaid =
          (this.some.prizesPaid || 0) + Number(item.prizes_paid);

        this.some.grossProfit =
          (this.some.grossProfit || 0) + Number(item.gross_profit);
      });
      // Qnt Agents
      this.some.agents = this.items.length;

      // Apenas 2 casas decimais
      if (this.some.grossProfit == undefined) return;
      this.some.grossProfit = this.some.grossProfit.toFixed(2);
      this.some.salesBets = this.some.salesBets.toFixed(2);
      this.some.commissionBets = this.some.commissionBets.toFixed(2);
      this.some.commissionLocal = this.some.commissionLocal.toFixed(2);
      this.some.prizesPaid = this.some.prizesPaid.toFixed(2);

      // To Copy
      this.some.grossProfitCopy = this.some.grossProfit
        .toString()
        .replace(".", ",");
      this.some.salesBetsCopy = this.some.salesBets
        .toString()
        .replace(".", ",");
      this.some.commissionBetsCopy = this.some.commissionBets
        .toString()
        .replace(".", ",");
      this.some.commissionLocalCopy = this.some.commissionLocal
        .toString()
        .replace(".", ",");

      this.some.prizesPaidCopy = this.some.prizesPaid
        .toString()
        .replace(".", ",");
      this.somaComissionRegionalCopy = this.somaComissionRegional
        .toString()
        .replace(".", ",");
      this.somaGrossLiquidCopy = this.somaGrossLiquid
        .toString()
        .replace(".", ",");

      this.resumeCopy = `${this.some.countBet}
        ${this.some.agents}
        ${this.some.salesBetsCopy}
        ${this.some.commissionBetsCopy}
        ${this.some.commissionLocalCopy}
        ${this.some.prizesPaidCopy} 
        ${this.some.grossProfitCopy}
        ${this.somaComissionRegionalCopy}
        ${this.somaGrossLiquidCopy}`;
    },
    typeCommissionText(type_comission) {
      const commissionLocal = {
        ngr: "NGR",
        bruto: this.$t("gross"),
      };
      return commissionLocal[type_comission];
    },

    getColor(value) {
      // Return Agente, Qtd Apostas, Qtd Crétido;
      // if (index == 0 || index == 1 || index == 5) return;
      if (value == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
